import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'btx-third-layout',
  templateUrl: './third-layout.component.html',
  styleUrls: ['./third-layout.component.scss']
})
export class ThirdLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
